import { configureStore } from '@reduxjs/toolkit'
import loginSlice from '../components/Login/loginSlice'
import ticketSlice from '../components/Tickets/ticketSlice'
import profileSlice from '../components/Profile/profileSlice'
import newsSlice from '../components/News/newsSlice'
import calendarSlice from '../components/Calendar/calendarSlice'
import documentsSlice from '../components/Documents/documentsSlice'
import proposalSlice from "../components/Proposal/proposalSlice";
import paymentsSlice from "../components/Payments/paymentsSlice";
import eventSlice from "../components/Event/NewYearEvent/eventSlice";
import contestSlice from "../components/Event/Contest/contestSlice";
import declarationSlice from "../components/Declaration/declarationSlice";
import storiesSlice from "../components/Stories/storiesSlice";
import notificationsSlice from "../components/Notifications/notificationsSlice";

export const store = configureStore({
  reducer: {
    loginSlice,
    ticketSlice,
    profileSlice,
    newsSlice,
    calendarSlice,
    documentsSlice,
    proposalSlice,
    paymentsSlice,
    eventSlice,
    contestSlice,
    declarationSlice,
    storiesSlice,
    notificationsSlice,
  }
})
